/** @jsxImportSource @emotion/react */
import { memo } from "react";

// CSS読み込み
import { blueButton, blueButton_inactive,waitingLabel } from "assets/css/stylesCss";

/**
 * 次へボタン
 * @param {String} value value属性用初期値
 * @param {Boolean} isActive 活性・非活性判定値
 * @param {Boolean} isAccepted 受付済み判定値
 * @param {Boolean} isInvalidDate ご希望日時有効判定値
 * @param {Boolean} isOutOfServiceArea サービス外エリア
 * @param {Boolean} isLoading データ通信中判定値
 */
const NextButton = memo(({ value, isActive, isAccepted = false, isInvalidDate = false, isOutOfServiceArea , isLoading = false}) => {

  return (
      <>
        {
          isLoading ? (
              <div css={blueButton_inactive}>
                <p css={waitingLabel}>通信中</p>
              </div>
              ) : (
          <input
            value={value}
            type="submit"
            css={isActive && !isAccepted && !isInvalidDate && !isOutOfServiceArea ? blueButton : blueButton_inactive}
          />
          )
        }
      </>
  );
});

export default NextButton;
